import script from "./ReportButtom.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportButtom.vue?vue&type=script&lang=ts&setup=true"

import "./ReportButtom.vue?vue&type=style&index=0&id=82fec6a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82fec6a6"]])

export default __exports__